import type { JSX } from "react";

import AppointmentAttendeesStep from "@/ui/components/schedule/booking/steps/AppointmentAttendeesStep";
import AppointmentAvailabilityStep from "@/ui/components/schedule/booking/steps/AppointmentAvailabilityStep";
import AppointmentConfirmationStep from "@/ui/components/schedule/booking/steps/AppointmentConfirmationStep";
import AppointmentDurationStep from "@/ui/components/schedule/booking/steps/AppointmentDurationStep";
import AppointmentOptionalAttendeesStep from "@/ui/components/schedule/booking/steps/AppointmentOptionalAttendeesStep";
import AppointmentPatientStep from "@/ui/components/schedule/booking/steps/AppointmentPatientStep";
import AppointmentProviderStep from "@/ui/components/schedule/booking/steps/AppointmentProviderStep";
import AppointmentRecurrenceStep from "@/ui/components/schedule/booking/steps/AppointmentRecurrenceStep";
import AppointmentSessionTypeStep from "@/ui/components/schedule/booking/steps/AppointmentSessionTypeStep";

interface BaseBookingStepProps {
  step: BookingStep;
}

const BookingStepMap: Record<BookingStep, JSX.Element> = {
  attendees: <AppointmentAttendeesStep step="attendees" />,
  availability: <AppointmentAvailabilityStep step="availability" />,
  confirmation: <AppointmentConfirmationStep step="confirmation" />,
  duration: <AppointmentDurationStep step="duration" />,
  optionalAttendees: (
    <AppointmentOptionalAttendeesStep step="optionalAttendees" />
  ),
  patient: <AppointmentPatientStep step="patient" />,
  provider: <AppointmentProviderStep step="provider" />,
  recurrence: <AppointmentRecurrenceStep step="recurrence" />,
  sessionType: <AppointmentSessionTypeStep step="sessionType" />,
};

export type { BaseBookingStepProps };
export default BookingStepMap;
